import Status from '@/components/status'
export default {
  name: 'view-detail',
  components: {Status},
  props: ['data'],
  data () {
    return {

    }
  },
  computed: {
    show () {
      return this.$store.getters['Document/getOpenView']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    }
  },
  mounted () {
  },
  methods: {
    approval (group_document = {}) {
    
      this.$store.dispatch('GroupDocument/approvalGroupDocument', {
        group_document
      }).then(res => {
        group_document.status = res.status
        
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        console.log(errors)
        
      })
    },

    rejection (group_document = {}) {
    
      this.$store.dispatch('GroupDocument/rejectGroupDocument', {
        group_document
      }).then(res => {
        group_document.status = res.status
        
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document/group-document/view-detail/view-detail.js